import React, { FC } from 'react'
import { Checkbox } from '@components/FormInputs/Checkbox'
import { Props } from './Question'
import { CheckboxWrapper } from './CheckboxFactory.elements'

export const CheckboxFactory: FC<Props> = (props) => {
  const { onAnswerQuestion, value } = props
  const {
    key,
    placeholder,
  } = props.inputData
  const selected: boolean = value === 'true'

  const handleChange = (answer: boolean) => {
    onAnswerQuestion(key, answer)
  }

  return (
    <CheckboxWrapper selected={selected}>
      <Checkbox
        label={placeholder || ''}
        checked={selected}
        onChange={handleChange}
        size="big"
        idPrefix={key}
        ariaLabel={placeholder}
      />
    </CheckboxWrapper>
  )
}
